import React from 'react';
import { isEqual } from 'lodash';
import { PanelType, useLeftSidePanelContext } from '../../context/LeftSidePanelContextProvider';
import { TimeFilterControl } from './TimeFilterControl';

const TimeFilterControlWrapper = () => {
  const { panel } = useLeftSidePanelContext();
  const isLeftPanelOpen = isEqual(panel, PanelType.IncidentsFeed) || isEqual(panel, PanelType.Filters);

  return <TimeFilterControl withLeftOffset={isLeftPanelOpen} />;
};

export { TimeFilterControlWrapper as TimeFilterControl };
